export const EXTRA_REHAB_LOCATIONS = ["Carpenters Arms", "Rainbow Promise"];

export default function getRehabLocations(dropDownData) {
  const base =
    dropDownData && Array.isArray(dropDownData.rehabLocation)
      ? dropDownData.rehabLocation.filter(Boolean)
      : [];

  const ordered = [...base, ...EXTRA_REHAB_LOCATIONS];

  return ordered.filter((location, index) => ordered.indexOf(location) === index);
}
